/**
 * @file
 * A JavaScript file containing the main menu functionality (small/large screen)
 *
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth


// (function (Drupal) { // UNCOMMENT IF DRUPAL.
//
//   Drupal.behaviors.mainMenu = {
//     attach: function (context) {

(function () { // REMOVE IF DRUPAL.

  'use strict';



  //Keyboard Nav, Should be own script?

  var rightClicked = false;

  const keyCodes = {
    left: [37, "ArrowLeft", "Left"],
    up: [38, "ArrowUp", "Up"],
    right: [39, "ArrowRight", "Right"],
    down: [40, "ArrowDown", "Down"],
    tab: [9, "Tab"],
    escape: [27, "Escape", "Esc"],
  };
  const navLinkSelector = '#global-menu .inline-menu__link';
  const navRootId = 'global-menu';

  var firstElement;
  var lastElement;

  var activeItem;

  function keyboardNav(){


    var navLinkItems = document.querySelectorAll(navLinkSelector);

    window.addEventListener('keydown', function(evt) {
      if(!evt.target.closest('#' + navRootId)){
        removeAllHover();

      }
    });

    window.addEventListener('mousedown', function(evt){
      if(!evt.target.closest('#' + navRootId)){
        removeAllHover();

      }
    });
    document.addEventListener('mousedown', function(evt){
      if(checkRightClick(evt)){
        removeAllHover();
      }
    });

    Array.prototype.forEach.call(navLinkItems, function(navLink){
      navLink.addEventListener('focus', toggleHover);
      navLink.addEventListener('keydown', keyboardActions);
    });

  }

  function removeAllHover(){
    //When esc is entered, remove all active/hover states set by script

    var allUl = getRoot().querySelectorAll('ul');

    Array.prototype.forEach.call(allUl, function(ulEl){
      ulEl.style.display = '';
      ulEl.style.opacity = '';
    });

  }

  function checkRightClick(evt) {
    //Check to see if the mousebutton was right or left. Store if left.
    if (evt.type == "mousedown" && evt.which == 3) {
      rightClicked = true;
    } else {
      rightClicked = false;
    }
    return rightClicked;
  }

  function toggleHover(evt) {

  }

  function keyboardActions(evt) {
    //Assign actions to all keycodes
      //Up - If on top level, should do nothing. If in child items, should nav back up list (wrap)
      //Down - If on top level, should drill down. If in child items, should got down list (wrap)
      //Right - if on top level, go to next item to right (wrap). If in children, jump to next parent to right .
      //Left - If on top level, go to previous item to left (wrap). If in children, jump to prev parent to left.
      //Escape should return focus to last active parent.
      //Any alphanumeric key should jump to nearest element with same letter. Stay at current level, don't dig down or jump up.
      var keypressed =  evt.key || evt.keyCode;
      var curAction = 'unsupported';


      for(const action in keyCodes) {
        if(keyCodes[action].indexOf(keypressed) !== false) {
            for(var i=0; i < keyCodes[action].length; i++){
              if( keyCodes[action][i] == keypressed){
                curAction = action;
              }
            }
        }
      }

      switch(curAction) {
        case "up":
          console.log("UP");

          if(!rootLevel(evt.target)) {
            activeItem = evt.target.parentNode;
            getFirstLastElms(evt.target);
            activeItem.querySelector('a').blur();
            if(activeItem == firstElement) {
              lastElement.querySelector('a').focus();
            } else if(activeItem == lastElement) {
              var prevSibling = getSibling('previous', evt.target);
              prevSibling.querySelector('a').focus();
            } else {
              var prevSibling = getSibling('previous', evt.target);
              prevSibling.querySelector('a').focus();
            }
          }
          evt.preventDefault();


          break;

        case "down":
          console.log("DOWN");
           if(rootLevel(evt.target)){
             evt.target.parentNode.querySelector('ul').firstElementChild.querySelector('a').focus();
             toggleSubLevel(evt.target.parentNode, 'show');
           } else {
             activeItem = evt.target.parentNode;
            getFirstLastElms(evt.target);
            activeItem.querySelector('a').blur();
            if(activeItem == lastElement) {
              firstElement.querySelector('a').focus();
            } else if(activeItem == firstElement) {
              var nextSibling = getSibling('next', evt.target);
              nextSibling.querySelector('a').focus();
            } else {
              var nextSibling = getSibling('next', evt.target);
              nextSibling.querySelector('a').focus();
            }
           }
           evt.preventDefault();
          break;

        case "left":


           if(rootLevel(evt.target)) {
             activeItem = evt.target.parentNode;
           } else {
             activeItem = getRoot(evt.target);
             //activeItem = evt.target.parentNode;
           }
           activeItem.querySelector('a').blur();
           toggleSubLevel(activeItem, 'hide');
           getFirstLastElms(activeItem.querySelector('a'));
           if (activeItem == firstElement){
            lastElement.querySelector('a').focus();
           }else {
            getSibling('previous', activeItem.querySelector('a')).querySelector('a').focus();
           }

            evt.preventDefault();
          break;

        case "right":
                      if(rootLevel(evt.target)) {
             activeItem = evt.target.parentNode;
           } else {
             activeItem = getRoot(evt.target);
             //activeItem = evt.target.parentNode;
           }
           activeItem.querySelector('a').blur();
           toggleSubLevel(activeItem, 'hide');
           getFirstLastElms(activeItem.querySelector('a'));
           if (activeItem == lastElement){
            firstElement.querySelector('a').focus();
           }else {
            getSibling('next', activeItem.querySelector('a')).querySelector('a').focus();
           }
           evt.preventDefault();
          break;

        case "tab":
           if(rootLevel(evt.target)) {
             activeItem = evt.target.parentNode;
             removeAllHover();
           } else {
             getFirstLastElms(evt.target);
             if(evt.target.parentNode == lastElement ) {
               removeAllHover();
             }
           }
          break;

        case "escape":
           removeAllHover();
          break;

        default:
           break;
      }
  }

  function rootLevel(anchor){
    if(anchor.parentNode.parentNode.parentNode.id === navRootId) {
      return true;
    }
    return false;
  }

  function toggleSubLevel(activeItem, state) {
    console.log(activeItem);
    if(!activeItem.querySelector('ul')) {
      return true;
    }
    switch(state){
      case "show":
        activeItem.querySelector('ul').style.display = 'block';
        activeItem.querySelector('ul').style.opacity = 1;
        activeItem.querySelector('ul').style.minWidth = 0;
        break;
      case "hide":
        activeItem.querySelector('ul').style.display = '';
        activeItem.querySelector('ul').style.opacity = '';
        activeItem.querySelector('ul').style.minWidth = '';
        break;
    }

  }

  function getFirstLastElms(anchor){
    firstElement = anchor.parentNode.parentNode.firstElementChild;
    lastElement = anchor.parentNode.parentNode.lastElementChild;
    return [firstElement, lastElement];
  }

  function getSibling(direction, anchor) {
    if(direction == 'undefined') {
      direction = 'previous';
    }
    var method = direction + "ElementSibling";
    return anchor.parentNode[method];
  }

  function getRoot(ele){
    if(ele) {
      var relativeRoot = ele.parentNode.parentNode.parentNode;
      return relativeRoot;
    } else {
      return document.getElementById(navRootId);
    }
  }


  keyboardNav();


})(); // REMOVE IF DRUPAL.

// })(Drupal); // UNCOMMENT IF DRUPAL.
